import { z } from "zod";

export const heatpumpCreateModelDtoSchema = z.object({
  name: z.string().min(1),
  brandId: z.number().min(1),
});

export type THeatpumpCreateModelDto = z.infer<typeof heatpumpCreateModelDtoSchema>;
